.steps {
	opacity: 0.6;
}
.contentHeader {
	font-size: 20px;
	margin-top: 30px;
	margin-bottom: 20px;
}

.dialogContent {
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.dialogInnerContent {
	text-align: center;
	width: 500px;
	display: flex;
	align-items: center;
	flex-direction: column;
}
.contentText {
	width: 500px;
}

.buttonBar {
	margin-top: 30px;
	margin-bottom: 30px;
	& > .skipButton {
		margin-right: 10px;
	}
}

.gutter {
	margin-top: 10px;
}

.hierarchyLink {
	color: var(--ds-text-inverse, var(--adg3-color-N0));
	text-decoration: underline;
}

.hierarchyLink:hover {
	color: var(--ds-text-inverse, var(--adg3-color-N0));
}

.hierarchyLink:focus {
	color: var(--ds-text-inverse, var(--adg3-color-N0));
}

.banner {
	width: 600px;
	height: 281px;
	background-size: contain;
	background-repeat: no-repeat;
	background-image: url('./onboarding-bg.png');
}
